import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { UserModel } from '../models/user.model';

export class UsersApiService extends ApiService {
  static endpoint = 'users';

  /**
   * @param {number | null} userId
   * @returns {string}
   * @protected
   */
  static buildUserUrl(userId = null) {
    return this.buildUrl(userId);
  }

  /**
   * @param {string | number} userId
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async get(userId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUserUrl(userId), {
      ...config,
      dataModel: UserModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {builderCallback|null} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUserUrl(), {
      ...config,
      dataModel: UserModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUserUrl(), data, {
      ...config,
      dataModel: UserModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string | number} userId
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async patch(userId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildUserUrl(userId), data, {
      ...config,
      dataModel: UserModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string | number} userId
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async delete(userId, config = {}) {
    return HttpApiClient.delete(this.buildUserUrl(userId), { ...config });
  }
}
